import {authFetch} from "../../network";

export async function api_recordPostImpressions(community,ids) {
    return await new Promise((resolve, reject) => {
        const res = () => {
            resolve();
        };
        const payload = {
            community_uid: community.uid,
            member_id: community.member_id,
            post_ids: ids
        };
        authFetch("/posts/count-impressions", res, res, "POST", {payload});
    })
}